import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { SubmissionError } from 'redux-form/immutable';
import ChangePasswordForm from 'components/ChangePasswordForm';
import NotificationWindow from 'components/NotificationWindow';
import {
  ERROR_SERVER_ERROR,
  GLOBAL_MESSAGES,
  GLOBAL_RESET_PASSWORD_SUCCESSFUL,
  GLOBAL_RESET_PASSWORD_TOKEN_INVALID,
  PASSWORD_SUCCESS_MESSAGE,
  PASSWORD_SUCCESS_MESSAGE_MOBILE
} from 'utils/messages';
import { isMobileDevice_DEPRECATED } from 'utils/mode';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);

    const token =
      this.props &&
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.token;

    this.state = {
      resetToken: token,
      resetTokenError: '',
      successful: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (this.state.resetToken) {
      this.props
        .validateToken(this.state.resetToken)
        .then(resp => {
          const valid =
            resp && resp.data && resp.data.isPasswordResetTokenValid;
          if (!valid) {
            this.setState({
              resetTokenError:
                valid === false
                  ? GLOBAL_MESSAGES[GLOBAL_RESET_PASSWORD_TOKEN_INVALID]
                  : ERROR_SERVER_ERROR
            });
          }
        })
        .catch(() => {
          this.setState({ resetTokenError: ERROR_SERVER_ERROR });
        });
    }
  }

  handleSubmit(values) {
    const input = values.toJS();

    return this.props
      .resetPassword(input.password, this.state.resetToken)
      .then(resp => {
        const result = resp && resp.data && resp.data.resetPassword;
        if (result && result.success) {
          this.setState({ successful: true });
          if (!isMobileDevice_DEPRECATED()) {
            this.props.redirectToLogin();
          }
        } else {
          const error = (result && result.message) || ERROR_SERVER_ERROR;
          throw new SubmissionError({ _error: error });
        }
        return resp;
      })
      .catch(error => {
        if (error instanceof SubmissionError) {
          throw error;
        } else {
          if (error.message) {
            console.error(error.message);
          } else {
            console.error(JSON.stringify(error));
          }
          throw new SubmissionError({ _error: ERROR_SERVER_ERROR });
        }
      });
  }

  render() {
    let content;
    if (this.state.resetTokenError) {
      content = (
        <NotificationWindow message={this.state.resetTokenError} closeUrl="/" />
      );
    } else if (this.state.successful) {
      const successMsg = isMobileDevice_DEPRECATED()
        ? PASSWORD_SUCCESS_MESSAGE_MOBILE
        : PASSWORD_SUCCESS_MESSAGE;
      content = (
        <NotificationWindow
          message={successMsg}
          closeUrl="/"
          variant={'success'}
        />
      );
    } else {
      content = (
        <ChangePasswordForm
          resetPassword={true}
          onSubmit={this.handleSubmit}
          closeUrl="/"
        />
      );
    }

    return content;
  }
}

const VALIDATE_TOKEN_QUERY = gql`
  mutation MyIsPasswordResetTokenValid($resetToken: String!) {
    isPasswordResetTokenValid(resetToken: $resetToken)
  }
`;

const RESET_PASSWORD_MUTATION = gql`
  mutation MyResetPassword($newPassword: String!, $resetToken: String!) {
    resetPassword(newPassword: $newPassword, resetToken: $resetToken) {
      success
      message
    }
  }
`;

const withValidateToken = graphql(VALIDATE_TOKEN_QUERY, {
  props: ({ ownProps, mutate }) => ({
    validateToken: resetToken => mutate({ variables: { resetToken } })
  })
});

const withResetPassword = graphql(RESET_PASSWORD_MUTATION, {
  props: ({ ownProps, mutate }) => ({
    resetPassword: (newPassword, resetToken) =>
      mutate({
        variables: { newPassword, resetToken }
      })
  })
});

const mapDispatchToProps = dispatch => ({
  redirectToLogin: () =>
    dispatch(
      push(`/login?message=${GLOBAL_RESET_PASSWORD_SUCCESSFUL}&variant=success`)
    )
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(
  withValidateToken(withResetPassword(ResetPasswordPage))
);
